import { SignoffRole } from 'types'

export type SignatureAnchorKind = 'signature' | 'date'

const ANCHOR_KINDS: readonly SignatureAnchorKind[] = ['signature', 'date']

/**
 * Cover-page cells reserved for e-signatures are marked with link annotations
 * carrying this private URI scheme, so the stamping step can find each cell's
 * exact rectangle in the rendered PDF without relying on layout math.
 */
const SCHEME = 'esign:'

export const signatureAnchorUri = (
  kind: SignatureAnchorKind,
  role: SignoffRole
) => `${SCHEME}${kind}/${role}`

export const parseSignatureAnchorUri = (
  uri: string
): { kind: SignatureAnchorKind; role: SignoffRole } | undefined => {
  if (!uri.startsWith(SCHEME)) return undefined
  const [rawKind, rawRole] = uri.slice(SCHEME.length).split('/')
  const kind = ANCHOR_KINDS.find((k) => k === rawKind)
  const role = Object.values(SignoffRole).find((r) => r === rawRole)
  return kind && role ? { kind, role } : undefined
}
